/* ============================================================
   FOREVER CASKET — SECTION BEHAVIOURS (fc-base.js)
   Tiny, dependency-free. Reveal-on-scroll, count-up numbers,
   scroll-snap carousels, single-open accordions.
   ============================================================ */
(function () {
  'use strict';

  document.documentElement.classList.add('fc-js');

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal on scroll ---------- */
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.fc-reveal:not(.fc-in), .fc-reveal-fade:not(.fc-in)');
    if (!els.length) return;
    if (reducedMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('fc-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fc-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Count-up numbers ----------
     <span data-fc-count="1500" data-fc-prefix="$" data-fc-suffix="+">1,500+</span> */
  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-fc-count'));
    if (isNaN(target)) return;
    var prefix = el.getAttribute('data-fc-prefix') || '';
    var suffix = el.getAttribute('data-fc-suffix') || '';
    var decimals = (el.getAttribute('data-fc-decimals') && parseInt(el.getAttribute('data-fc-decimals'), 10)) || 0;
    var duration = parseInt(el.getAttribute('data-fc-duration') || '1400', 10);
    var start = null;
    function fmt(v) {
      var s = v.toFixed(decimals);
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return prefix + parts.join('.') + suffix;
    }
    if (reducedMotion) { el.textContent = fmt(target); return; }
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 4);
      el.textContent = fmt(target * eased);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initCounts(root) {
    var els = (root || document).querySelectorAll('[data-fc-count]:not([data-fc-counted])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.setAttribute('data-fc-counted', '1'); animateCount(el); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.setAttribute('data-fc-counted', '1');
          animateCount(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Carousel ----------
     <div data-fc-carousel><div class="fc-carousel">…</div>
       <button data-fc-prev></button><button data-fc-next></button></div> */
  function initCarousels(root) {
    (root || document).querySelectorAll('[data-fc-carousel]:not([data-fc-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-fc-ready', '1');
      var track = wrap.querySelector('.fc-carousel');
      var prev = wrap.querySelector('[data-fc-prev]');
      var next = wrap.querySelector('[data-fc-next]');
      if (!track) return;
      function stepSize() {
        var item = track.children[0];
        if (!item) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return item.getBoundingClientRect().width + gap;
      }
      function update() {
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      }
      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -stepSize(), behavior: reducedMotion ? 'auto' : 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: stepSize(), behavior: reducedMotion ? 'auto' : 'smooth' });
      });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Single-open accordion groups ----------
     <div class="fc-acc" data-fc-single> <details>… */
  function initAccordions(root) {
    (root || document).querySelectorAll('.fc-acc[data-fc-single]:not([data-fc-ready])').forEach(function (group) {
      group.setAttribute('data-fc-ready', '1');
      group.addEventListener('toggle', function (e) {
        var d = e.target;
        if (d.tagName === 'DETAILS' && d.open) {
          group.querySelectorAll('details[open]').forEach(function (other) {
            if (other !== d) other.open = false;
          });
        }
      }, true);
    });
  }

  function initAll(root) {
    initReveals(root);
    initCounts(root);
    initCarousels(root);
    initAccordions(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Re-init inside the Shopify theme editor */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  window.FCBase = { init: initAll };
})();
